import * as React from "react";
import { ConfirmProvider as UiConfirmProvider } from "@mandrac/ui";
import { useI18n } from "./i18n";

/** Mounts the shared confirm dialog with translated default labels. `dock` = phone layout. */
export function ConfirmProvider({ children, dock }: { children: React.ReactNode; dock?: boolean }) {
  const { t } = useI18n();
  return (
    <UiConfirmProvider confirmLabel={t("common.confirm")} cancelLabel={t("common.cancel")} dock={dock}>
      {children}
    </UiConfirmProvider>
  );
}

export { useConfirm, type ConfirmOptions } from "@mandrac/ui";
